
const iconZone = 'https://coleman-lindberg-music.b-cdn.net/assets/icons/'

export const alt = 'musicians playing for an audience'
export const icons = 
{
    notFound: `${iconZone}/404Icon.png`,
    doubleLeft: `${iconZone}/doubleLeft.svg`,
    doubleRight: `${iconZone}/doubleRight.svg`,
    download: `${iconZone}/download.svg`,
    facebook: `${iconZone}/facebook.svg`,
    guitar: `${iconZone}/guitar.svg`,
    piggy: `${iconZone}/piggy.svg`,
    quoteEnd: `${iconZone}/quoteEnd.png`,
    quoteStart: `${iconZone}/quoteStart.png`,
    singleLeft: `${iconZone}/singleLeft.svg`,
    singleRight: `${iconZone}/singleRight.svg`
}

export const albumZones = {
    audio: 'https://coleman-lindberg-music.b-cdn.net',
    video: '',
    background: 'https://coleman-lindberg-music.b-cdn.net/assets/backgrounds',
    featured: 'https://coleman-lindberg-music.b-cdn.net/assets/featured',
    cover: 'https://coleman-lindberg-music.b-cdn.net/assets/covers',
    
}

export const dec16thBandPractice = [
        
        // url: 'https://coleman-lindberg-music.b-cdn.net/assets/Dec16th',
       {main: 'https://coleman-lindberg-music.b-cdn.net/assets/Dec16th/twentyone.jpeg', alt: 'musicians playing for an audience'},
      
        {img: 'https://coleman-lindberg-music.b-cdn.net/assets/Dec16th/sixteen.jpeg', alt: 'musicians playing for an audience'},
        
        {img: 'https://coleman-lindberg-music.b-cdn.net/assets/Dec16th/nineteen.jpeg', alt: 'musicians playing for an audience'},
        // {img: 'https://coleman-lindberg-music.b-cdn.net/assets/Dec16th/fifteen.jpeg', alt: 'musicians playing for an audience'}, 
        {img: 'https://coleman-lindberg-music.b-cdn.net/assets/Dec16th/fourteen.jpeg', alt: 'musicians playing for an audience'},
        {img: 'https://coleman-lindberg-music.b-cdn.net/assets/Dec16th/thirteen.jpeg', alt: 'musicians playing for an audience'},
        {img: 'https://coleman-lindberg-music.b-cdn.net/assets/Dec16th/twelve.jpeg', alt: 'musicians playing for an audience'},
        // {img: 'https://coleman-lindberg-music.b-cdn.net/assets/Dec16th/eleven.jpeg'},
        // {img: 'https://coleman-lindberg-music.b-cdn.net/assets/Dec16th/ten.jpeg'},
        // {img: 'https://coleman-lindberg-music.b-cdn.net/assets/Dec16th/nine.jpeg'},
        // {img: 'https://coleman-lindberg-music.b-cdn.net/assets/Dec16th/eight.jpeg'},
        {img: 'https://coleman-lindberg-music.b-cdn.net/assets/Dec16th/seven.jpeg', alt: 'musicians playing for an audience'},
        // {img: 'https://coleman-lindberg-music.b-cdn.net/assets/Dec16th/six.jpeg'},
        // {img: 'https://coleman-lindberg-music.b-cdn.net/assets/Dec16th/five.jpeg'},
        // {img: 'https://coleman-lindberg-music.b-cdn.net/assets/Dec16th/four.jpeg'},
        // {img: 'https://coleman-lindberg-music.b-cdn.net/assets/Dec16th/three.jpeg'},
        // {img: 'https://coleman-lindberg-music.b-cdn.net/assets/Dec16th/two.jpeg'},
        // {img: 'https://coleman-lindberg-music.b-cdn.net/assets/Dec16th/one.jpeg'}
       
]

export const decShow = [
    {main: 'https://coleman-lindberg-music.b-cdn.net/assets/DecShow/one.jpeg'},
    
    {img: 'https://coleman-lindberg-music.b-cdn.net/assets/DecShow/two.jpeg'},
    {img: 'https://coleman-lindberg-music.b-cdn.net/assets/DecShow/three.jpeg'},
    {img: 'https://coleman-lindberg-music.b-cdn.net/assets/DecShow/four.jpeg'},
    {img: 'https://coleman-lindberg-music.b-cdn.net/assets/DecShow/five.jpeg'},
    {img: 'https://coleman-lindberg-music.b-cdn.net/assets/DecShow/six.jpeg', },
    {img: 'https://coleman-lindberg-music.b-cdn.net/assets/DecShow/seven.jpeg'},
    {img: 'https://coleman-lindberg-music.b-cdn.net/assets/DecShow/eight.jpg'},
    {img: 'https://coleman-lindberg-music.b-cdn.net/assets/DecShow/nine.jpg'}
]


